import { Chakra } from "@airhelp/react-ui-components";
import { checkListPadding, Icons } from "./CheckList.config";
import type { CheckListProps } from "./CheckList.d";

const { VStack, Heading, List, ListItem, Text } = Chakra;

const CheckList = ({ heading, bgColor, listItems, iconPosition, containerFilling, fontSize }: CheckListProps) => (
  <VStack bg={bgColor} borderRadius="xl" flexDir="column" p={checkListPadding[containerFilling]} align="left">
    {heading && (
      <Heading variant="h4" as="h4" fontWeight={400} mb={4}>
        {heading}
      </Heading>
    )}
    <List>
      {listItems.map(({ text, _uid, iconType }) => {
        const Icon = Icons[iconType].icon;

        return (
          <ListItem key={_uid} d="flex" alignItems={iconPosition} _notLast={{ mb: 6 }}>
            <Icon color={Icons[iconType].color} boxSize={6} />
            <Text textAlign="left" fontSize={fontSize} ml={4}>
              {text}
            </Text>
          </ListItem>
        );
      })}
    </List>
  </VStack>
);

export default CheckList;
